/*  DUI Frame
*
*	Used for displaying other pages in iframe popup.
*
*	DUIframe.open({
*       url,    		string				- page URL to open in iframe
*       beforeOpen      function			- called before starting to load page
*       afterLoad     	function 			- called after page is loaded in iframe
*       beforeClose     function 			- called right after closing has been triggered but not yet started 
											  If false is returned, the closing will be stopped.
*       afterClose     	function 			- called after closing iframe
*   );
*
*	DUIframe.close();
*/

window.DUIframe = (function() {
	"use strict";

	var frameEl = $('<iframe/>', {
		id: 'DUIframe',
		style: 'opacity: 0; width:0; height:0; border:none; background: transparent; margin:0; padding:0; overflow: hidden; transition: opacity .2s ease-in',
		scrolling: 'auto',
		frameborder: '0',
		allowtransparency: 'true'
	}),
	containerEl = $('<div>', {
		id: 'DUIframeContainer',
		style: 'position:fixed; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; border:none; background: rgba(0,0,0,.4); margin:0; padding:0; overflow:hidden; z-index:9998;',
		html: frameEl
	}),
	settings = {},

	loaded = function() {
		$('#dproProgressIndicator').parent().hide();
		$(frameEl)
			.css({ 'width': '100%', 'height': '100%', 'opacity': '1' })
			.contents().find('.DUIPanel-close').bind('click', DUIframe.close)
				 .end().find('#dproProgressIndicator').css('position', 'fixed')
					   .find('#dproProgressIndicatorBox').css('margin-top', '-40px');

		if (typeof settings.afterLoad === 'function') {
			settings.afterLoad();
		}
	},

	unloaded = function() {
		containerEl.detach();
		$(document.documentElement).removeClass('DUISetup-lock');

		if (typeof settings.afterClose === 'function') {
			settings.afterClose();
		}
	},

	open = function (frameSettings) {
		if (close() !== false) {
			if (typeof frameSettings === 'string') {
				settings = {url: frameSettings};
			} else {
				settings = frameSettings;
			}

			if (typeof settings.beforeOpen !== 'function' || settings.beforeOpen() !== false) {
				$('#dproProgressIndicator').parent().show();
				frameEl.get(0).setAttribute('src', encodeURI(settings.url));
				frameEl.unbind('load').bind('load', loaded);
				$(document.body).append(containerEl);
				$(document.documentElement).addClass('DUISetup-lock');
			}
		}
	},

	close = function () {
		if (typeof settings.beforeClose === 'function' && settings.beforeClose() === false) 
			return false;

		frameEl.unbind('load').bind('load', unloaded);
		frameEl.attr('src', '');
	};

	return {
		containerEl: containerEl,
		frameEl: frameEl,
		open: open,
		close: close
	};

})();